module.exports = __webpack_public_path__ + "static/media/nivit.d60865c2.jpg";